<div class="row mt-2 no-gutters">
  <div class="col">
    <small>
      <a [routerLink]="{'RENTAL_FLEET': ['/rental-fleet'], 'FLEET_MANAGEMENT_COMPANY': ['/commercial-fleet'], 'MOBILITY_COMPANY': ['/commercial-fleet'], 'FIELD_SERVICE_COMPANY': ['/commercial-fleet'], 'DEALER': ['/dealer'], 'CORPORATE': ['/corporate'], 'FINANCING_GROUP': ['/corporate']}[accountCategory]" class="text-secondary">Admin Console</a>
      &nbsp;/&nbsp;<a [routerLink]="['/notifications']" class="text-secondary">Notifications</a>
    </small>
  </div>
</div>

<div class="row mt-2">
  <div class="col-12">
    <app-notifications></app-notifications>
  </div>
</div>